module.exports = __webpack_public_path__ + "images/facebook.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook.svg
// module id = 518
// module chunks = 0